<div class="container-fluid">
  <div class="row">
    <div class="col">
      <shrd-uic-message
        variant="completion"
        [type]="messageType.SIGN_WARNING"
        [useContainer]="false"
        headline="{{ 'shared.messages.exception.genericError.headline' | i18next }}"
      >
        <p class="mb-1" [innerHTML]="'userManagement.messages.exception.message' | i18next"></p>
      </shrd-uic-message>
    </div>
  </div>
</div>
